import api from '../utilities/api';
import { getCookie } from '../utilities/cookie';

const getProcedure = (id) => {
  return api.get(`/pp/procedures/external/${id}/`);
};

const postRequest = (data) => {
  return api.post(`/pp/procedures/application/`, data);
};

const getApplicationForm = () => {
  return api.get('/pp/procedures/procedure-application/active/ ');
};

const getMyProcedures = (params) => {
  return api.get(`/pp/procedures/${getCookie('mu_id')}/user/applications/`, {
    params: { ...params, name__contains: params?.search ?? '' },
  });
};

const getRequest = (id, userId) => {
  return api.get(
    `/pp/procedures/application/external/${id}/view/?id=${userId}`,
  );
};

const getFormData = (id) => {
  return api.get(`/pp/procedures/application/${id}/form/`);
};

const downloadApplication = (url) => {
  return api.get(url, {
    responseType: 'blob',
  });
};

const postRequestToWK = (id, formData) => {
  return api.patch(`/pp/procedures/${id}/upload/`, formData, {
    headers: { 'content-type': 'multipart/form-data' },
  });
};

const getRequestToWK = (id, return_url = '') => {
  return api.get(`/pp/procedures/${id}/mdok/`, { params: { return_url } });
};

export {
  getProcedure,
  postRequest,
  getApplicationForm,
  getMyProcedures,
  getRequest,
  getFormData,
  downloadApplication,
  postRequestToWK,
  getRequestToWK,
};
